/* eslint-disable ban/ban */
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class MobileMenu extends ThemeComponent {
    @Ref childrenMenu!: HTMLElement[];
    @Ref menuWrapper!: HTMLElement;

    private open: string = '';
    private _onOpenChange = new SimpleEvent<string>();

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: string) {
        this.open = open;

        // Use the private backing field to dispatch
        this._onOpenChange.dispatch(open);
    }
    /**
     * Initialise.
     */
    init() {
        this.eventListeners();
    }

    /**
     * Event Listeners
     */
    eventListeners() {
        this.openMenu();
        this.closeChildren();
    }

    /**
     * Open Side Cart.
     */
    openMenu() {
        document.addEventListener('openMenu', () => {
            this._onOpenChange.dispatch(this.open);
        });
    }

    closeChildren() {
        document.addEventListener('closeMenu', () => {
            this.childrenMenu.forEach((item) => {
                item.classList.remove('is-active','no-scroll');
                this.menuWrapper?.classList.remove('no-scroll');
            });
        });
    }
}
